// src/hooks/useProcuringEntity.js
import { useState, useContext, useEffect } from "react";
import API from "../API";
import { AppContext } from "../context/AppContext";

import { useHistory } from "react-router-dom";

const useLogin = (isLoggingIn, loginValues) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const history = useHistory();

  const { setProjects, selectProcuringEntity, setSelectedProject, setCurrentUser } = useContext(AppContext);
  useEffect(() => {
    
    const transformProjects = (projects) => {
      return projects.map((project) => ({
        id: project.id,
        name: project.name,
        code: project.code,
        wb_project_id: project.wb_project_id,
        project_status_id: project.project_status_id,
        procuring_entities: (project.procuring_entities || []).map((entity) => ({
          procuring_entity_id: entity.procuring_entity_id,
          council_name: entity.council?.name,
        })),
      }));
    };          
                
    const fetchProjects = async (loginValues) => {
      try {
        // Start loading before login
        setLoading(true);
    
        // Login and fetch access token
        const loginResponse = await API.login(loginValues);
        localStorage.setItem("accessToken", loginResponse.data.access_token);
        setCurrentUser(loginResponse.data.user);
    
        // After login, fetch projects
        const projectResponse = await API.getProjects();
        const projects = projectResponse.data.data;
    
        // Transform and set projects
        const transformedProjects = transformProjects(projects);
        setProjects(transformedProjects);
    
        // Set the default project and procuring entity
        const defaultProject = transformedProjects?.[0];
        const defaultProjectId = defaultProject?.id;
        setSelectedProject(defaultProjectId);
        const selectedProcurementId = defaultProject?.procuring_entities?.[0]?.procuring_entity_id;
        selectProcuringEntity(selectedProcurementId);

        // Redirect to the unified project overview page using the PROJECT id
        if (defaultProjectId) {
          history.push(`/project/${defaultProjectId}/overview`);
        }
    
      } catch (err) {
        console.error("Failed to fetch projects or login", err);
        setErrorMessage(err.message);
      } finally {
        // Stop loading regardless of success or error
        setLoading(false);
      }
    };
    

    isLoggingIn && fetchProjects(loginValues);

  }, [setProjects, 
      selectProcuringEntity, 
      setSelectedProject, 
      isLoggingIn, 
      loginValues,
      setCurrentUser,
      history
  ]);

  return { loading, errorMessage };
};

export default useLogin;